class Video {
    constructor() {
        this.bannerVideo = document.querySelector('.banner__video');
        this.events();
    }

    events() {
        
        this.bannerVideo.addEventListener('click', () => {

            this.bannerVideo.currentTime = 0;
            // Request fullscreen
            if (this.bannerVideo.requestFullscreen) {
                this.bannerVideo.requestFullscreen();
            } else if (this.bannerVideo.webkitRequestFullscreen) { // Safari
                this.bannerVideo.webkitRequestFullscreen();
            } else if (this.bannerVideo.msRequestFullscreen) { // IE/Edge
                this.bannerVideo.msRequestFullscreen();
            }

            // Show controls and unmute
            //this.bannerVideo.controls = true;
            this.bannerVideo.muted = false;

            // Check fullscreen state
            this.detectFullscreen();
        });
    }

    detectFullscreen() {
        document.addEventListener('fullscreenchange', () => {
            if (document.fullscreenElement === this.bannerVideo) {
                console.log('Video is in fullscreen mode');
            } else {
                console.log('Video exited fullscreen mode');
                // Mute the video and hide controls
                this.bannerVideo.muted = true;
                this.bannerVideo.controls = false;
            }
        });

        // For Safari
        document.addEventListener('webkitfullscreenchange', () => {
            if (document.webkitFullscreenElement === this.bannerVideo) {
                console.log('Video is in fullscreen mode (Safari)');
            } else {
                console.log('Video exited fullscreen mode (Safari)');
                // Mute the video and hide controls
                this.bannerVideo.muted = true;
                this.bannerVideo.controls = false;
            }
        });
    }
}

export default Video;